import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoggedUserService } from "../services/common/logged-user.service";

import { MaterialModule } from "../material.module";

@Component({
  selector: "app-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.css"],
  imports: [MaterialModule]
})
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private loggedUserService: LoggedUserService
  ) {}

  ngOnInit(): void {
    // Component loaded - local user data already cleared by service
    // Don't perform Microsoft sign-out yet to allow showing the success page
  }

  redirectToLogin(): void {
    // Now perform Microsoft sign out and redirect to root for re-authentication
    this.loggedUserService.performSignOut();
    setTimeout(() => {
      window.location.href = "/";
    }, 100);
  }
}
